<div class="top-nav-container p-4 hidden lg:block" [ngClass]="{ 'top-nav-customise': isHomePage, 'nav-hidden': !isNavVisible, 'nav-visible': isNavVisible }">
  <img class="xl:w-[225px] lg:w-[225px] md:w-[180px] sm:w-[160px] w-[160px] fixed top-[13px] cursor-pointer"
    [ngClass]="{ 'img-customise': isHomePage }" src="assets/img/azone-wordmark.svg" routerLink="/" />
  <p class="title fixed top-[69px] lg:text-[15px] md:text-[15px] sm:text-[14px] text-[12px] font-bold ms-1 mt-[3px]"
    [ngClass]="{
      'fade-out': isFadingOut,
      'fade-in': isFadingIn,
      'title-customise': isHomePage,
    }">
    {{ currentTitle }}
  </p>
  <div class="flex-auto flex justify-end">
    <div class="min-w-[600px] flex space-x-[5px] mt-[20px] items-center">
      @for (link of navbarList; track link) {
      <a class="bg-link-style text-[#ffffff] flex items-center h-12 p-3 text-decoration-none rounded-lg transition-all duration-300 ease-in-out font-medium" @fadeInOut
        [ngClass]="{ 'link-customise': isHomePage }" [routerLink]="link.routerLink[1]"
        routerLinkActive="bg-link-style-active">
        {{ link.label | translate | async }}
      </a>
      }
      <button class="bg-link-style search-trigger text-[#ffffff] flex items-center h-12 p-3 text-decoration-none rounded-lg transition-all duration-300 ease-in-out hover:text-[#a5eb55]"
        [ngClass]="{ 'link-customise': isHomePage }" (click)="openSearch()" type="button" aria-label="Open site search">
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <path
            d="M11 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm9.7 14.3a1 1 0 0 1 0 1.4 1 1 0 0 1-1.4 0l-3.2-3.2a1 1 0 1 1 1.4-1.4l3.2 3.2z" />
        </svg>
      </button>
    </div>
  </div>
</div>

<div class="top-nav-mobile-container p-2 lg:hidden" [ngClass]="{ 'top-nav-customise': isHomePage, 'nav-hidden': !isNavVisible, 'nav-visible': isNavVisible }">
  <img class="w-[160px] cursor-pointer" [ngClass]="{ 'img-customise': isHomePage }" src="assets/img/azone-wordmark.svg"
    routerLink="/" />
  <button class="mobile-search" (click)="openSearch()" type="button" aria-label="Open site search">
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path
        d="M11 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm9.7 14.3a1 1 0 0 1 0 1.4 1 1 0 0 1-1.4 0l-3.2-3.2a1 1 0 1 1 1.4-1.4l3.2 3.2z" />
    </svg>
  </button>
  <p class="title g:text-[15px] md:text-[15px] sm:text-[14px] text-[12px] text-[#ffffff] font-bold ms-1" [ngClass]="{
      'fade-out': isFadingOut,
      'fade-in': isFadingIn,
      'title-customise': isHomePage,
    }">
    {{ currentTitle }}
  </p>
  <button class="mobile-nav ml-auto" (click)="toggleMenu()" type="button" aria-controls="navbar-menu"
    [attr.aria-expanded]="isMenuOpen">
    @if (!isMenuOpen) {
    <img [ngClass]="{ 'mobile-menu': isHomePage }" src="../../../../../assets/icons/menu.svg" alt="Menu" />
    }
    @if (isMenuOpen) {
    <img src="../../../../../assets/icons/close.svg" alt="Close" />
    }
  </button>
</div>

@if (isMenuOpen) {
<div id="navbar-menu" class="mobile-container lg:hidden" [ngClass]="{ 'mobile-menu-visible': isMobileMenuActive }"
  role="dialog" aria-modal="true" aria-label="Site menu">
  <div class="mobile-menu-shell">
    <div class="mobile-menu-brand">
      <div class="mobile-menu-brand-mark">
        <img class="mobile-menu-logo" src="assets/img/azone-wordmark.svg" alt="AZone" routerLink="/" (click)="toggleMenu()" />
        @if (currentTitle) {
        <p class="mobile-menu-expertise" aria-live="polite" [ngClass]="{ 'fade-out': isFadingOut, 'fade-in': isFadingIn }">
          {{ currentTitle }}
        </p>
        }
      </div>
      <button class="mobile-menu-close" (click)="toggleMenu()" type="button" aria-controls="navbar-menu"
        [attr.aria-expanded]="isMenuOpen" aria-label="Close menu">
        <img src="../../../../../assets/icons/close.svg" alt="" aria-hidden="true" />
      </button>
    </div>

    <nav class="mobile-menu-list" aria-label="Mobile navigation">
    @for (link of navbarList; track link) {
      <a class="mobile-menu-link" [routerLink]="link.routerLink[1]" routerLinkActive="mobile-menu-link-active"
        (click)="toggleMenu()">
        <span @fadeInOut>{{ link.label | translate | async }}</span>
      </a>
    }
    </nav>

    <button class="mobile-menu-search-action" (click)="openSearch()" type="button" aria-label="Open site search">
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path
          d="M11 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm9.7 14.3a1 1 0 0 1 0 1.4 1 1 0 0 1-1.4 0l-3.2-3.2a1 1 0 1 1 1.4-1.4l3.2 3.2z" />
      </svg>
      <span>{{ 'app.search' | translate | async }}</span>
    </button>
  </div>
</div>
}

<app-site-search [isOpen]="isSearchOpen" (closed)="closeSearch()"></app-site-search>
